import { Component, Input } from '@angular/core';
import { IDemandSupplier } from '../../../demand/types/IDemandSupplierContact';
import { supplierDisplayName } from '@lib/supplier';

interface ISupplierPreview {
    readonly displayName: string;
    readonly contact: IDemandSupplier['contact']['contact'];
}

@Component({
    selector: 'purchase-requisition-supplier-preview',
    templateUrl: './purchase-requisition-supplier-preview.component.html',
    styleUrls: ['./purchase-requisition-supplier-preview.component.scss'],
    standalone: false
})
export class PurchaseRequisitionSupplierPreviewComponent {
    public supplierPreviews: readonly ISupplierPreview[] = [];

    @Input() public set suppliers(suppliers: IDemandSupplier[]) {
        this.supplierPreviews = suppliers.map((supplier) => ({
            displayName: supplierDisplayName(supplier.supplierNumber, supplier.contact.companyName),
            contact: supplier.contact.contact,
        }));
    }

    public showExtended = false;
}
